export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 13.ed635fe4.jpg";